<mbs-card-group>
  <ng-container *ngTemplateOutlet="keysTmp"></ng-container>
</mbs-card-group>
<mbs-card-group>
  <ng-container *ngTemplateOutlet="endpointsTemplate"></ng-container>
</mbs-card-group>

@if (storageType === StorageType.Minio) {
  <mbs-s3-compatible-additional-options
    [form]="form"
    [isNativeMultipartControlShown]="isNativeMultipartControlShown"
    [storageType]="storageType"></mbs-s3-compatible-additional-options>
}

<ng-template #keysTmp>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.accessKey"
      [boldLabel]="true"
      [formControl]="accessKey"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.accessKey' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.accessKey' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input-password
      [attr.data-e2e]="e2eLocators.secretKey"
      [autocomplete]="'new-password'"
      [boldLabel]="true"
      [disabledEye]="secretKey.value === fakeSecretKey"
      [formControl]="secretKey"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.secretKey' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.secretKey' | i18next"
      [showRequiredMark]="false"></mbs-input-password>
  </mbs-form-group>
</ng-template>

<ng-template #endpointsTemplate>
  <mbs-form-group>
    <mbs-input-label
      [boldLabel]="true"
      [label]="'Protocol'"></mbs-input-label>

    <div class="row">
      <div class="col-auto">
        <mbs-radio
          [attr.data-e2e]="e2eLocators.https"
          [formControl]="isHttps"
          [label]="'HTTPS'"
          [value]="true"></mbs-radio>
      </div>
      <div class="col-auto">
        <mbs-radio
          [attr.data-e2e]="e2eLocators.http"
          [formControl]="isHttps"
          [label]="'HTTP'"
          [value]="false">
        </mbs-radio>
      </div>
    </div>
  </mbs-form-group>

  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.endpoint"
      [boldLabel]="true"
      [formControl]="endpoint"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.endpoint' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.endpointExample' | i18next"
      [showRequiredMark]="false">
    </mbs-input>
  </mbs-form-group>
</ng-template>
